import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, MenuItem, Select, Skeleton, Typography, useTheme } from "@mui/material";
import { Square } from "@mui/icons-material";
import { IoIosArrowDown } from "react-icons/io";
import { useGetChangeImpactQuery } from "store/slices/apis/claimsAndChangeOrderDashboardSlice";
import { useParams } from "react-router-dom";

const ImpactChangeOrders = () => {
    const { projectId } = useParams();
    const theme = useTheme();
    const { data, isLoading } = useGetChangeImpactQuery({ projectId });
    const projectCost = data?.data?.toProjectCost ?? 0;
    const changeCost = data?.data?.totalChangeOrderCost ?? 0;

    let options = {
        chart: {
            type: "solidgauge",
            height: "90%",
            backgroundColor: 'transparent',
        },
        title: {
            text: "",
            style: { fontSize: "18px" },
        },
        pane: {
            startAngle: 0,
            endAngle: 360,
            size: "100%",
            center: ['52%', '50%'],
            background: [
                {
                    outerRadius: "",
                    innerRadius: "88%",
                    backgroundColor: Highcharts.color("#7cb5ec").setOpacity(0.3).get(),
                    borderWidth: 0,
                },
                {
                    outerRadius: "",
                    innerRadius: "63%",
                    backgroundColor: Highcharts.color("#90ed7d").setOpacity(0.3).get(),
                    borderWidth: 0,
                },
                {
                    outerRadius: "",
                    innerRadius: "38%",
                    backgroundColor: Highcharts.color("#f7a35c").setOpacity(0.3).get(),
                    borderWidth: 0,
                },
            ],
        },
        yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            tickPositions: [],
        },
        plotOptions: {
            solidgauge: {
                dataLabels: {
                    enabled: false,
                },
                linecap: "round",
                stickyTracking: false,
            },
        },
        tooltip: {
            enabled: false
        },
        legend: {
            enabled: false,
            align: "center",
            verticalAlign: "bottom",
            layout: "horizontal",
        },
        series: [
            {
                name: "Total Project Cost",
                data: [{ y: projectCost, color: "#E8E3E3", radius: "75%", innerRadius: "85%" }]
            },
            {
                name: "Total Cost of Change",
                data: [{ y: changeCost, color: "#CB402D", radius: "60%", innerRadius: "70%" }]
            },
        ],
        credits: {
            enabled: false,
        },
    };

    return (
        <Box sx={{ backgroundColor: "white", mt: "10px", border: "1px solid #D8D8D8", borderRadius: "12px" }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Box sx={{ paddingLeft: "17px" }}>
                    <Typography variant="h6" sx={{ mb: 1, color: `${theme?.customSettings?.themeColor}`, fontWeight: "500", fontSize: '18px', paddingTop: "20px", lineHeight: "100%", letterSpacing: "0.4px" }}>
                        Impact of Change Orders
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2, color: "#182A4E80" }}>
                        Evaluate change order costs to manage scope adjustments and budget control
                    </Typography>
                </Box>
                {/* <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={10}
                    IconComponent={IoIosArrowDown}
                    sx={{
                        backgroundColor: '#E8E8E8',
                        color: '#474747',
                        fontWeight: 500,
                        fontSize: '16px',
                        lineHeight: '24px',
                        letterSpacing: '-0.4px',
                        '& .MuiOutlinedInput-input': {
                            padding: '5px 15px'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                        }
                    }}
                >
                    <MenuItem value={10}>Value</MenuItem>
                </Select> */}
            </Box>

            <Grid2 container>
                <Grid2 size={{ xs: 12, md: 7 }}>
                    <List sx={{ padding: 0, mt: 2, paddingLeft: "17px" }}>
                        <ListItem sx={{ paddingLeft: 0 }}>
                            <ListItemIcon sx={{ minWidth: '25px' }}>
                                <Square style={{ color: '#E8E3E3', height: '17px', width: '17px' }} />
                            </ListItemIcon>
                            <ListItemText primary={`Total Project Cost: ${projectCost}`} sx={{
                                color: "#182A4E",
                                whiteSpace: "nowrap",
                                '& .MuiTypography-root': {
                                    fontSize: '16px',
                                    lineHeight: '100%',
                                    fontWeight: 500,
                                    letterSpacing: '-0.4px'
                                }
                            }} />
                        </ListItem>
                        <ListItem sx={{ paddingLeft: 0 }}>
                            <ListItemIcon sx={{ minWidth: '25px' }}>
                                <Square style={{ color: '#CB402D', height: '17px', width: '17px' }} />
                            </ListItemIcon>
                            <ListItemText primary={`Total Cost of Change Orders: ${changeCost}`} sx={{
                                color: "#182A4E",
                                whiteSpace: "nowrap",
                                '& .MuiTypography-root': {
                                    fontSize: '16px',
                                    lineHeight: '100%',
                                    fontWeight: 500,
                                    letterSpacing: '-0.4px'
                                }
                            }} />
                        </ListItem>
                    </List>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5 }} sx={{ mt: -1 }}>
                    {isLoading ? (
                        <Skeleton variant="circular" width={200} height={200} sx={{ mt: 4, mb: 4, mr: 3 }} />
                    ) : (
                        <HighchartsReact highcharts={Highcharts} options={options} />
                    )}
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default ImpactChangeOrders;
